// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3303k","location":"Header_location__S5x0Q"};